export default __webpack_public_path__ + "static/Montserrat-LightItalic-d79f80a4862fa88db7c2f8c847d1e258.ttf";